import type { LucideIcon, LucideProps } from 'lucide-react';
import { forwardRef } from 'react';

/**
 * Lucide-shaped GitHub mark. lucide-react v1.x dropped brand icons, so
 * we ship our own with the same forwardRef + LucideProps shape so it's a
 * drop-in for any `icon: LucideIcon` prop (e.g. `<IconButton icon={GithubIcon} />`).
 */
export const GithubIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    { size = 24, color = 'currentColor', strokeWidth: _ignored, ...rest },
    ref,
  ) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      aria-hidden="true"
      {...rest}
    >
      <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56v-1.97c-3.2.7-3.87-1.54-3.87-1.54-.52-1.33-1.27-1.69-1.27-1.69-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.02 1.75 2.68 1.24 3.33.95.1-.74.4-1.24.73-1.53-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.29 1.18-3.09-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.15 1.18a10.96 10.96 0 0 1 5.74 0c2.19-1.49 3.14-1.18 3.14-1.18.63 1.58.24 2.75.12 3.04.74.8 1.18 1.83 1.18 3.09 0 4.42-2.69 5.39-5.25 5.68.41.36.78 1.07.78 2.16v3.21c0 .31.21.67.8.56C20.71 21.39 24 17.08 24 12c0-6.35-5.15-11.5-12-11.5z" />
    </svg>
  ),
) as LucideIcon;
GithubIcon.displayName = 'GithubIcon';
